import { rowBucket } from "@/utils/equipmentLocks";

export function findPrefillTarget(items, equipmentId, currentScheduleId) {
    if (!equipmentId || !Array.isArray(items) || !items.length) return null;

    const row = items.find(
        item => item && item.equipment && item.equipment.equipment_id === equipmentId
    );
    if (!row) return null;

    const bucket = rowBucket(row.equipment, row.scheduleDetail || {}, currentScheduleId || null);
    return { equipment_id: equipmentId, bucket };
}
